import { useTranslation } from '@centric-os/helpers';
import * as yup from 'yup';

export default () => {
  const { translate } = useTranslation();
  const numberTransform = (value: any) => (isNaN(value) ? undefined : value);

  const schema = yup.object().shape({
    originalTime: yup.number().transform(numberTransform).optional().nullable(),
    time: yup
      .number()
      .transform(numberTransform)
      .min(1, translate('errorMessages.genericRequired'))
      .required(translate(`errorMessages.genericRequired`)),
    averagePrepTime: yup
      .number()
      .transform(numberTransform)
      .required(translate(`errorMessages.genericRequired`))
      .min(1, translate('errorMessages.genericRequired')),
    customers_per_slot: yup
      .number()
      .transform(numberTransform)
      .required(translate(`errorMessages.genericRequired`))
      .min(1, translate('errorMessages.genericRequired')),
  });

  return {
    schema,
  };
};
